<script>
  import alertify from "alertifyjs";
  import { onMount } from "svelte";
  import { Modal, ModalBody, ModalFooter, ModalHeader } from "sveltestrap";
  import backend from "../../../../../server";
  import { events } from "../../../../../js/events";
  import { sections, languages, status } from "../../../../../js/constants";
  import Configuration from "../../../../../config";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let showModalEditBanner;
  export let client;
  export let carruselInfo = {};
  export let selectitem;
  export let isNew = true;
  let CarouselTemp = [];
  let dateRanges = [];
  let filters = { page: 1, xpage: 20 };
  let bannerFiles = [];
  let orderSet = new Set();
  let minOrder = Infinity;
  let maxOrder = -Infinity;
  let categories = ["slot", "slot_live", "crash", "virtual"];
  let isSaving = false;
  let brands = [];
  let filteredBrands;
  let searchData = "";
  let isDropdownOpen = false;
  let cacheVersion = Date.now();
  let params = {
    client_id: client.id,
    client_code: client.code.toLowerCase(),
    ...filters,
  };

  const FIELDS_TO_COMPARE = [
    "category",
    "device",
    "language",
    "section",
    "title",
    "status",
  ];

  const conf = Configuration.getConfiguration();

  const modalTitle = () => {
    return isNew ? "Carrusel Nuevo" : `Carrusel ${carruselInfo.title}`;
  };

  if (filters.startTime) params.startTime = filters.startTime;
  if (filters.endTime) params.endTime = filters.endTime;

  onMount(async () => {
    let response = await backend.client.listCarrusels(params);
    CarouselTemp = response?.data?.data || [];
    listBrandsByCategory();
    if (isNew) resetCarrusel();
  });

  const onShowEditBanner = () => (showModalEditBanner = !showModalEditBanner);

  const resetCarrusel = () => {
    carruselInfo = {
      ...carruselInfo,
      title: "",
      items: [],
    };
    addItem();
  };

  const addItem = (afterIndex = null) => {
    if (!carruselInfo.items) {
      carruselInfo.items = [];
    }
    const newItem = {
      imageName: "",
      title: "",
      timeInterval: 10,
      serial: "",
      startTime: "",
      endTime: "",
      orderView: 1,
      status: 1,
      eventClick: "onCategoryChange('Home')",
      sizeView: "full width",
      imagen: null,
      gameId: "",
      externalUrl: "",
      brandName: "",
      customCategory: "slot",
    };
    if (afterIndex === -1) {
      carruselInfo.items = [newItem, ...carruselInfo.items];
    } else if (afterIndex !== null && afterIndex >= 0) {
      const head = carruselInfo.items.slice(0, afterIndex + 1);
      const tail = carruselInfo.items.slice(afterIndex + 1);
      carruselInfo.items = [...head, newItem, ...tail];
    } else {
      carruselInfo.items = [...carruselInfo.items, newItem];
    }
    normalizeOrders();
  };

  const listBrandsByCategory = async () => {
    try {
      let data = await backend.brands.listBrandsByCategory();
      brands = data.data.sort();
    } catch (error) {
      console.error("Error al listar las marcas por categoría", error);
    }
  };

  function filterBrands() {
    filteredBrands = brands.filter((brand) =>
      brand.toLowerCase().includes(searchData.toLowerCase()),
    );
  }

  function selectBrand(brand) {
    banner.brandName = brand;
    isDropdownOpen = false;
  }

  function toggleDropdown() {
    isDropdownOpen = !isDropdownOpen;
    if (isDropdownOpen) {
      searchData = "";
      filterBrands();
    }
  }

  const buildCarruselPayload = () => {
    return {
      // index: carruselInfo.index || null,
      title: carruselInfo.title,
      client_id: client.id,
      client_code: params.client_code,
      category: carruselInfo.category,
      section: carruselInfo.section,
      device: carruselInfo.device,
      language: carruselInfo.language,
      status: carruselInfo.status,
      startTime: carruselInfo.startTime,
      endTime: carruselInfo.endTime,
      items:
        carruselInfo.items?.map((item) => ({
          imgUrl: item.imgUrl || null,
          imageName: item.imageName,
          title: item.title,
          timeInterval: Number(item.timeInterval),
          serial: item.serial || null,
          startTime: item.startTime || null,
          endTime: item.endTime || null,
          orderView: item.orderView,
          status: item.status,
          eventClick: item.eventClick || "",
          sizeView: item.sizeView || "full width",
          externalUrl: item.externalUrl || "",
          brandName: item.brandName || "",
          gameId: item.gameId || "",
          customCategory: item.customCategory || "",
          fileKey: item.fileKey || null,
          fileChange: item.fileChange || false,
        })) || [],
    };
  };

  const getCredentialsURL = async (file, key) => {
    const url = await backend.client.obtainPresignedURL({
      fileName: key,
      contentType: file.type,
    });
    return url.data;
  };

  const isDuplicateCarousel = (carousels, newCarousel, excludeIndex = null) => {
    return carousels.some(
      (carousel, index) =>
        index !== excludeIndex &&
        FIELDS_TO_COMPARE.every(
          (field) => carousel[field] === newCarousel[field],
        ),
    );
  };

  const isDuplicateImage = (carousels, newCarousel, excludeIndex = null) => {
    const normalize = (name) => name?.trim().toLowerCase();
    const imageNames = newCarousel.items
      .map((item) => normalize(item.imageName))
      .filter(Boolean);
    const hasInternalDuplicates =
      new Set(imageNames).size !== imageNames.length;
    if (hasInternalDuplicates) return true;
    return carousels.some((carousel, index) => {
      if (excludeIndex !== null && index === excludeIndex) return false;

      return carousel.items?.some((item) =>
        imageNames.includes(normalize(item.imageName)),
      );
    });
  };
  function normalizeOrders() {
    if (!carruselInfo.items) return;
    carruselInfo.items.forEach((item, i) => {
      item.orderView = i + 1;
    });
  }

  const save = async () => {
    if (!validateForm()) return;
    carruselInfo.client_id = client.id;
    normalizeOrders();
    try {
      isSaving = true;
      let payload = buildCarruselPayload();
      const indexToExclude = isNew ? null : selectitem;
      if (
        isDuplicateCarousel(CarouselTemp, payload, isNew ? null : selectitem)
      ) {
        console.log("este carrusel ya existe");
        alertify.error("Ya existe un carrusel con la misma configuración");
        return;
      }
      if (isDuplicateImage(CarouselTemp, payload, indexToExclude)) {
        alertify.error(
          "El nombre de la imagen se está repitiendo: " +
            payload.items[indexToExclude].imageName,
        );
        return;
      }
      payload.items = payload.items.map((item, index) => {
        let imageName = item.imageName;
        let finalFileKey = item.fileKey;
        if (bannerFiles[index]?.file) {
          let extension = bannerFiles[index].file.name.split(".").pop();
          finalFileKey = `${client.code.toLowerCase()}/${imageName}.${extension}`;
        }
        return {
          ...item,
          imageName,
          fileKey: finalFileKey,
        };
      });

      await Promise.all(
        payload.items.map(async (banner, index) => {
          if (!bannerFiles[index]?.file) return;
          let url = await getCredentialsURL(
            bannerFiles[index].file,
            banner.fileKey,
          );
          let response = await fetch(url, {
            method: "PUT",
            body: bannerFiles[index].file,
          });
          if (!response.ok) throw new Error(`Error subiendo imagen ${index}`);
        }),
      );

      isNew ? CarouselTemp.push(payload) : (CarouselTemp[selectitem] = payload);
      await backend.client.saveCarrusel(CarouselTemp);
      cacheVersion = Date.now();
      alertify.success(
        isNew ? "Creado correctamente" : "Actualizado correctamente",
      );
      dispatch("saved", {
        carrusel: { ...carruselInfo, ...payload },
        isNew: isNew,
      });

      showModalEditBanner = false;
    } catch (error) {
      console.error(error);
      const msg = error?.response?.data?.message || error?.message || "Hubo un error al procesar la solicitud";
      alertify.error(msg);
    } finally {
      isSaving = false;
    }
  };

  const handleUploadBannerImage = (event, index) => {
    const files = event.target.files;
    if (carruselInfo.items[index].fileKey != null)
      carruselInfo.items[index].fileChange = true;
    else carruselInfo.items[index].fileChange = false;
    console.log(carruselInfo.items[index].fileChange);

    if (files && files.length > 0) {
      const file = files[0];
      const objectUrl = URL.createObjectURL(file);
      bannerFiles[index] = {
        file,
        contentType: file.type,
        fileName: file.name,
      };
      carruselInfo.items[index].previewUrl = objectUrl;
    } else {
      bannerFiles[index] = null;
      carruselInfo.items[index].fileChange = false;
      carruselInfo.items[index].previewUrl = null;
      carruselInfo.items[index].fileKey = null;
    }
  };

  const validateForm = () => {
    let isValid = true;
    if (!carruselInfo.title.trim()) {
      alertify.error("El título es obligatorio.");
      isValid = false;
    }
    if (!carruselInfo.category) {
      alertify.error("La categoría es obligatoria.");
      isValid = false;
    }
    if (carruselInfo.startTime && carruselInfo.endTime) {
      const startTime = new Date(carruselInfo.startTime);
      const endTime = new Date(carruselInfo.endTime);
      if (startTime >= endTime) {
        alertify.error(
          "La fecha de inicio del carrusel debe ser anterior a la fecha final.",
        );
        isValid = false;
      }
    }

    // Validar campos de cada banner
    carruselInfo.items.forEach((item, index) => {
      if (!item.title.trim()) {
        alertify.error(`El título del banner ${index + 1} es obligatorio.`);
        isValid = false;
        return;
      }
      if (!item.imageName.trim()) {
        alertify.error(
          `El nombre de la imagen/video del banner ${index + 1} es obligatorio.`,
        );
        isValid = false;
        return;
      }
      switch (item.eventClick) {
        case "openGame":
          if (!item.gameId.trim()) {
            alertify.error(
              `El Id del juego del banner ${index + 1} es obligatorio.`,
            );
            isValid = false;
            return;
          }
          break;
        case "openExternalUrl":
          if (!item.externalUrl.trim()) {
            alertify.error(`El enlace del banner ${index + 1} es obligatorio.`);
            isValid = false;
            return;
          }
          break;
        case "openBrand":
          if (!item.customCategory) {
            alertify.error(
              `Debe seleccionar una categoria en el banner ${index + 1}.`,
            );
            isValid = false;
            return;
          }
          if (!item.brandName) {
            alertify.error(
              `Debe seleccionar una marca en el banner ${index + 1}.`,
            );
            isValid = false;
            return;
          }
          break;
        case "":
          if (!item.eventClick.trim()) {
            alertify.error(
              `Debe serleccionar una opción de redirección en el banner ${index + 1}.`,
            );
            isValid = false;
            return;
          }
          break;
      }
      const interval = String(item.timeInterval);
      const isEmptyOrNoNumbers = !interval || !/\d/.test(interval);
      const hasManyDots = (interval.match(/\./g) || []).length > 1;

      if (isEmptyOrNoNumbers || hasManyDots) {
        alertify.error(
          `Intervalo inválido: el banner ${index + 1} debe contener al menos un número y solo un punto decimal.`,
        );
        isValid = false;
        return;
      }

      if (item.startTime && item.endTime) {
        const startTime = new Date(item.startTime);
        const endTime = new Date(item.endTime);
        if (startTime >= endTime) {
          alertify.error(
            `La fecha de inicio del banner ${index + 1} debe ser anterior a la fecha final.`,
          );
          isValid = false;
          return;
        }
      }
      orderSet.add(item.orderView);
      minOrder = Math.min(minOrder, item.orderView);
      maxOrder = Math.max(maxOrder, item.orderView);
    });

    if (orderSet.size > 0) {
      const expectedSize = maxOrder - minOrder + 1;
      if (orderSet.size !== expectedSize || minOrder !== 1) {
        alertify.error(
          "El orden de visualización debe ser secuencial y empezar en 1.",
        );
        isValid = false;
        return;
      }
    }
    return isValid;
  };

  if (carruselInfo?.items) {
    carruselInfo.items.forEach((item, index) => {
      if (!item.previewUrl && item.imgUrl) {
        item.previewUrl = item.imgUrl.startsWith("http") ? item.imgUrl : `${conf.ASSETS}${item.imgUrl}`;
      }
    });
  }

  const isOnlyNumber = (event) => {
    // Permitir números y el carácter de punto
    if (!/[\d.]/.test(event.key)) {
      event.preventDefault();
      alertify.error("Ingrese solo números o un punto decimal");
    }
  };

  let showDataCarrusel = true;

  const removeArticulo = (index) => {
    try {
      alertify.confirm(
        "Eliminar Banner",
        "¿Está seguro de que desea eliminar este banner?",
        () => {
          carruselInfo.items.splice(index, 1);
          carruselInfo.items = [...carruselInfo.items];
          normalizeOrders();
          alertify.success("Banner eliminado");
        },
        () => {},
      );
    } catch (error) {
      alertify.error("Error al intentar eliminar el banner");
    }
  };
  const scrollToItems = () => {
    const header = document.querySelector(".articulos-header");
    if (header) {
      header.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToTop = () => {
    const modalBody = document.querySelector(".carrusel-modal-body");
    if (modalBody) {
      modalBody.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
</script>

<Modal
  isOpen={showModalEditBanner}
  toggle={onShowEditBanner}
  class="modal-fullscreen"
>
  <ModalHeader toggle={onShowEditBanner}>
    <b>{modalTitle()}</b>
  </ModalHeader>
  <ModalBody class="carrusel-modal-body">
    {#if isSaving}
      <div class="loading-slider-container">
        <div class="loading-slider-bar"></div>
      </div>
    {/if}
    <div class="container-carrusel">
      <button class="toggle-details" on:click={() => (showDataCarrusel = !showDataCarrusel)}>
        <i class="fa-solid {showDataCarrusel ? 'fa-chevron-up' : 'fa-chevron-down'}"></i>
        {showDataCarrusel ? 'Ocultar' : 'Mostrar'} detalles del carrusel
      </button>
      <div class="collapse-wrapper" class:collapsed={!showDataCarrusel}>
        <div class="data-carrusel">
          <div class="form-group">
            <span><b>Nombre:</b></span>
            <input type="text" bind:value={carruselInfo.title} required />
          </div>
          <div class="form-group">
            <span><b>Dispositivo:</b></span>
            <select bind:value={carruselInfo.device}>
              <option value="Desktop">Desktop</option>
              <option value="Mobile">Mobile</option>
            </select>
          </div>
          <div class="form-group">
            <span><b>Pagina:</b></span>
            <select class="form-control" bind:value={carruselInfo.category}>
              <option value="Home">Home</option>
            </select>
          </div>
          <div class="form-group">
            <span><b>Sección del Banner:</b></span>
            <select class="form-control" bind:value={carruselInfo.section}>
              {#each sections as section}
                <option value={section.value}>{section.label}</option>
              {/each}
            </select>
          </div>
          <div class="form-group">
            <span><b>Idioma:</b></span>
            <select bind:value={carruselInfo.language}>
              {#each languages as language}
                <option value={language.value}>{language.label}</option>
              {/each}
            </select>
          </div>
          <div class="form-group">
            <span><b>Estado:</b></span>
            <select class="form-control" bind:value={carruselInfo.status}>
              {#each status as status}
                <option value={status.value}>{status.label}</option>
              {/each}
            </select>
          </div>
          <div class="form-group">
            <span><b>Hora de inicio:</b></span>
            <input type="datetime-local" bind:value={carruselInfo.startTime} />
          </div>
          <div class="form-group">
            <span><b>Hora final:</b></span>
            <input type="datetime-local" bind:value={carruselInfo.endTime} />
          </div>
        </div>
      </div>

      <div class="articulos-container">
        <div class="articulos-header">
          <h3 class="title-banner"><b>Items de Carrusel</b></h3>
          <button class="btn btn-primary btn-sm" on:click={() => { addItem(-1); scrollToItems(); }}>
            ✚ Añadir al inicio
          </button>
        </div>
        <div class="grid-articulos">
          {#if carruselInfo.items.length > 0}
            {#each carruselInfo.items as banner, index}
              <div class="articulo">
                <div class="form-group">
                  <span>Titulo:</span>
                  <input type="text" bind:value={banner.title} />
                </div>

                <!-- nombre de imagen -->

                <div class="form-group">
                  <span>Nombre de la Imagen:</span>
                  <input
                    type="text"
                    bind:value={banner.imageName}
                    disabled={banner.serial !== ""}
                  />
                </div>
                <div class="form-group">
                  <span>Intervalo (en segundos)</span>
                  <input
                    bind:value={banner.timeInterval}
                    on:keypress={isOnlyNumber}
                  />
                </div>
                <div class="form-group">
                  <span>Enlace:</span>
                  <input type="text" bind:value={banner.fileKey} disabled />
                </div>
                <div class="form-group">
                  <span>Fecha de inicio</span>
                  <input type="datetime-local" bind:value={banner.startTime} />
                </div>
                <div class="form-group">
                  <span>Fecha final</span>
                  <input type="datetime-local" bind:value={banner.endTime} />
                </div>
                <div class="form-group">
                  <span>Orden vizualización</span>
                  <input type="number" bind:value={banner.orderView} min="1" disabled/>
                </div>
                <div class="form-group">
                  <span>Redirecionar a:</span>
                  <select bind:value={banner.eventClick}>
                    {#each events as event}
                      <option value={event.value}>{event.label}</option>
                    {/each}
                  </select>
                  {#if banner.eventClick === "openGame"}
                    <div class="form-group">
                      <span>Ingrese Game ID:</span>
                      <input
                        bind:value={banner.gameId}
                        placeholder="ID del juego"
                        class="form-control"
                      />
                    </div>
                  {/if}

                  {#if banner.eventClick === "openExternalUrl"}
                    <div class="form-group">
                      <span>Ingrese URL externa:</span>
                      <input
                        bind:value={banner.externalUrl}
                        placeholder="https://ejemplo.com"
                        class="form-control"
                      />
                    </div>
                  {/if}

                  {#if banner.eventClick === "openBrand"}
                    <div class="form-group">
                      <span>Seleccione la categoria:</span>
                      <br />
                      <span>{banner.customCategory}</span>
                      <select
                        class="form-control"
                        bind:value={banner.customCategory}
                      >
                        {#each categories as category}
                          <option>{category}</option>
                        {/each}
                      </select>
                    </div>
                    <div class="form-group">
                      <span>Ingrese el nombre de la marca:</span>
                      <select
                        class="form-control"
                        bind:value={banner.brandName}
                      >
                        <option value="" disabled selected
                          >Seleccione una marca</option
                        >
                        {#each brands as brand}
                          <option>{brand}</option>
                        {/each}
                      </select>
                    </div>
                  {/if}
                </div>
                <!-- <div class="form-group">
                  <span>Tamaño</span>
                  <select bind:value={banner.sizeView}>
                    <option value="full width">Full width</option>
                    <option value="half width">Half width</option>
                  </select>
                </div> -->
                <div class="form-group">
                  <span>Estado</span>
                  <select bind:value={banner.status}>
                    {#each status as status}
                      <option value={status.value}>{status.label}</option>
                    {/each}
                  </select>
                </div>
                <div class="form-group">
                  <span>Imagen/Video</span>
                  <input
                    type="file"
                    on:change={(e) => handleUploadBannerImage(e, index)}
                  />
                  <img
                    src={banner.previewUrl}
                    on:error={(e) => {
                      if (e.target.src !== banner.previewUrl && banner.imgUrl) {
                        e.target.src = banner.imgUrl.startsWith("http") ? banner.imgUrl : `${conf.ASSETS}${banner.imgUrl}`;
                      }
                    }}
                    alt="Vista previa"
                    class="img-preview"
                  />
                </div>
                <!-- aquii -->
                <button
                  class="btn btn-danger"
                  on:click={() => removeArticulo(index)}>Borrar</button
                >
                <button
                  class="btn btn-primary"
                  on:click={() => addItem(index)}>Añadir</button
                >
              </div>
            {/each}
          {:else}
            <p>No hay artículos en el carrusel.</p>
          {/if}
        </div>
      </div>
    </div>
  </ModalBody>
  <ModalFooter>
    <button on:click={save} disabled={isSaving} class="btn">
      {#if isSaving}
        Subiendo archivos...
      {:else}
        Guardar Todo
      {/if}
    </button>
  </ModalFooter>
  <button class="btn-scroll-top" on:click={scrollToTop} title="Volver arriba">
    <i class="fa-solid fa-arrow-up"></i>
  </button>
</Modal>

<style>
  .loading-slider-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: #e2e8f0;
    overflow: hidden;
    z-index: 1051;
  }

  @keyframes loading-slide {
    from {
      left: -40%;
    }
    to {
      left: 100%;
    }
  }

  .container-carrusel {
    transition: opacity 0.3s ease;
  }
  :global(.carrusel-modal-body.modal-body) {
    padding: 0;
    position: relative;
  }

  .btn-scroll-top {
    position: absolute;
    bottom: 6rem;
    right: 2rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: #6e0e94f5;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    transition: opacity 0.2s ease;
    margin: 0;
    padding: 0;
  }

  .btn-scroll-top:hover {
    opacity: 0.85;
  }

  .container-carrusel {
    width: 100%;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .collapse-wrapper {
    overflow: hidden;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    max-height: 600px;
    opacity: 1;
  }

  .collapse-wrapper.collapsed {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }

  .toggle-details {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: none;
    border: 1px solid #6e0e94f5;
    border-radius: 4px;
    padding: 0.4rem 0.75rem;
    font-size: 0.9rem;
    cursor: pointer;
    color: #6e0e94f5;
    margin: 0;
    margin-bottom: 0.5rem;
    width: fit-content;
  }

  .toggle-details:hover {
    background-color: #f8f9fa;
  }

  .data-carrusel,
  .grid-articulos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
    padding: 0.5rem;
  }
  .grid-articulos {
    background-color: #bdbcbc;
  }

  .articulo {
    border: 1px solid #dee2e6;
    padding: 15px;
    border-radius: 8px;
    background-color: #fff;
  }

  .articulos-container {
    position: relative;
  }

  .articulos-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #e9e6e6;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #a0a0a0;
  }

  .title-banner {
    font-size: 1.25rem;
    margin: 0;
  }

  input,
  select {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ced4da;
    border-radius: 4px;
  }
  select {
    background-color: #b0c6f765;
  }
  input:disabled{
    background-color: #e9ecef;
  }
  .btn {
    margin-top: 10px;
    padding: 10px 20px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .btn-danger {
    background-color: #dc3545;
  }

  .btn-primary {
    background-color: #007bff;
  }

  .btn:hover {
    opacity: 0.8;
  }

  .img-preview,
  .video-preview {
    max-width: 100%;
    height: auto;
    margin-top: 1rem;
  }
</style>
